module.exports = __webpack_public_path__ + "img/b.def212ed.png";